import { mapState, mapActions, mapMutations } from 'vuex'
import maNavbarCategory from '@/components/navbarCategories'
import maNavbarStepper from '@/components/navbarStepper'
import buttonBotton from '@/components/button-blue'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_DELETE_DAMAGE,
  FNOL_DAMAGES_CONFIRMED_MUT,
  FNOL_MODULE_NAME
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { FLOW_STATES } from '../../../../modules/Flow/constants'

export default {
  name: 'damagesConfirmed',

  mixins: [flowMixin, userFlowMixin],

  components: {
    maNavbarCategory,
    buttonBotton,
    maNavbarStepper
  },

  data: function () {
    return {
      damagesDetails: [],
      title: '',
      showCartDetail: false,
      damageId: null,
      showDeleteBtn: false,
      mursQuantity: null,
      literalEvaluePar: '',
      titleBienesImobCategory: '',
      showEmpty: false,
      surfaceInfo: {
        key: '',
        literal: ''
      },
      surfaceObjects: [],
      imagesList: []
    }
  },

  computed: {
    flowName() {
      return this.getUserFlow
    },
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterSummary: 'sinisterSummary'
    })
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY,
      actWarrantyDeleteDamage: WARRANTY_DELETE_DAMAGE
    }),
    ...mapMutations(FNOL_MODULE_NAME, {
      mutDamagesConfirmed: FNOL_DAMAGES_CONFIRMED_MUT
    }),

    filterSinisterDamagesSumary() {
      const damageCategories = this.stateWarrantySinisterSummary.reduce(
        function (r, a) {
          r[a.selfcare_title] = r[a.selfcare_title] || []
          r[a.selfcare_title].push(a)
          return r
        },
        Object.create(null)
      )

      Object.values(damageCategories).forEach((category) => {
        this.damagesDetails.push(category)
      })

      this.addMursQty()
      this.removeSurfaceDetails()
      this.addGlobalSurface()
    },

    addMursQty() {
      this.damagesDetails.forEach((damageCategory) => {
        damageCategory.forEach((item) => {
          if (item.selfcare_subtitle.toUpperCase().indexOf('MUR') !== -1) {
            let objMurs = {
              key: 'Nombre de murs touchés',
              literal: item.selfcare_subtitle.substring(0, 1)
            }
            item.details.push(objMurs)
          }
        })
      })
    },
    handleSurfaceDetail (detail, damageCategory) {
      if (this.surfaceObjects.length === 0) {
        const surfaceLiteral = detail.literal.replace('m²', '')
        const subtitle = damageCategory[0].selfcare_subtitle
        this.surfaceObjects.push({
          key: 'Surface (en mètres carrés)',
          literal: surfaceLiteral,
          selfcare_subtitle: subtitle
        })
      } else {
        this.surfaceObjects.forEach((object) => {
          if (
            object.selfcare_subtitle !==
            damageCategory[0].selfcare_subtitle
          ) {
            const surfaceLiteral = detail.literal.replace('m²', '')
            const subtitle = damageCategory[0].selfcare_subtitle
            this.surfaceObjects = [
              ...this.surfaceObjects,
              {
                key: 'Surface du salon (en mètres carrés)',
                literal: surfaceLiteral,
                selfcare_subtitle: subtitle
              }
            ]
          }
        })
      }
    },
    removeSurfaceDetails() {
      this.damagesDetails.forEach((damageCategory) => {
        damageCategory.forEach((item) => {
          item.details.forEach((detail, ind) => {
            if (detail.literal.indexOf('m²') !== -1) {
              this.titleBienesImobCategory = item.selfcare_subtitle
              this.literalEvaluePar = detail.key
              item.details.splice(ind, 1)
              this.handleSurfaceDetail(detail, damageCategory)
            }
          })
        })
      })
      this.damagesDetails.forEach((damageCategory) => {
        damageCategory.forEach((item) => {
          this.imagesList = item.images
          item.details.forEach((detail, ind) => {
            if (detail.literal === this.literalEvaluePar) {
              item.details.splice(ind, 1)
            }
          })
        })
      })
    },

    addGlobalSurface() {
      this.damagesDetails.forEach((damageCategory) => {
        damageCategory.forEach((category) => {
          const surfaceTargetObj = this.surfaceObjects.find(
            (item) => item.selfcare_subtitle === category.selfcare_subtitle
          )
          if (surfaceTargetObj) {
            damageCategory[0]['surface'] = surfaceTargetObj
          }
        })
      })
    },

    surfaceIsVisible(titleCategory) {
      return titleCategory && this.titleBienesImobCategory === titleCategory
    },

    getSubtitle(subtitle) {
      if (subtitle.toUpperCase().indexOf('MUR') !== -1) {
        this.mursQuantity = subtitle.substring(0, 1)
        return 'Murs'
      } else {
        return subtitle
      }
    },

    handleClickAcceptDamages() {
      if (this.getFnolId && this.getFlowState === FLOW_STATES.SMART) {
        const fnolViewName = 'fnol-flow'
        this.mutDamagesConfirmed(true)
        this.goToView(fnolViewName)
      } else {
        this.goToNextState()
      }
    },

    handleClickReviseDamages() {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },

    handleDeleteDamage() {
      const damageId = this.damageId
      const sinisterId = this.getSinisterId
      this.actWarrantyDeleteDamage({ damageId, sinisterId }).then(() => {
        this.showDeleteBtn = false
        this.handleClickReviseDamages()
      })
    },

    getImageSrc(imgName, imgList) {
      let imgSrc = []
      imgList.forEach((img) => {
        if (img.imageType === imgName) {
          imgSrc.push(img.imageContent)
        }
      })
      return imgSrc
    }
  },

  mounted() {
    const sinisterId = this.getSinisterId
    this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
      this.filterSinisterDamagesSumary()
    })
  }
}
